import { BehaviorScrollToTop } from "~/enums"

export const scrollToTop = (
  top: number = 0,
  behavior: BehaviorScrollToTop = BehaviorScrollToTop.Smooth,
  timeout: number = 0
): void => {
  setTimeout(() => {
    window.scrollTo({
      top,
      left: 0,
      behavior
    })
  }, timeout)
}
